import { render } from "./Column.vue?vue&type=template&id=1a2d23bf"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"
script.render = render

export default script